import _asyncToGenerator from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { EvUserPreferencesApi } from "../../apiclient/api/EvUserPreferencesApi";
import { sortDefaultOptions, highlightOptions, showPreviewOptions, resultsPerPageOptions, advancedDisplayOptions, downloadLocationOptions, downloadOutputOptions, downloadFormatOptions } from "../../components/fragments/doc/Dialogs/Preferences/PreferencesConstants";
var userPreferences = new EvUserPreferencesApi();
export var fetchUserPreferences = createAsyncThunk("UserPreferences/get", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", userPreferences.fetchUserPreferences());
        case 1:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})));
export var updateUserPreferences = createAsyncThunk("UserPreferences/update", /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(pref) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", userPreferences.updateUserPreferences(pref));
          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}());
var initialState = {
  userPreferences: {
    status: "init",
    payload: {
      sort: sortDefaultOptions[0],
      navigatorOrder: "",
      highlight: highlightOptions[0],
      showPreview: showPreviewOptions[0],
      resultsPerPage: resultsPerPageOptions[0],
      autosuggestOff: false,
      advOptionsDisplay: advancedDisplayOptions[0],
      userMask: 0,
      dlLocation: downloadLocationOptions[0],
      dlOutput: downloadOutputOptions[0],
      dlFormat: downloadFormatOptions[0],
      dlSummary: "false",
      dlRemoveSelected: "false",
      dlFileNamePrefix: "Engineering_Village"
    }
  }
};
var userPreferencesSlice = createSlice({
  name: "userPreferences",
  initialState: initialState,
  reducers: {
    // omit reducer cases
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchUserPreferences.pending, function (state) {
      state.userPreferences.status = "pending";
    }).addCase(fetchUserPreferences.fulfilled, function (state, _ref3) {
      var _payload$_embedded;
      var payload = _ref3.payload;
      state.userPreferences.status = "done";
      // eslint-disable-next-line no-underscore-dangle
      state.userPreferences.payload = (_payload$_embedded = payload._embedded) === null || _payload$_embedded === void 0 ? void 0 : _payload$_embedded.userPrefses[0];
    }).addCase(fetchUserPreferences.rejected, function (state) {
      state.userPreferences.status = "error";
    }).addCase(updateUserPreferences.pending, function (state) {
      state.userPreferences.status = "pending";
    }).addCase(updateUserPreferences.fulfilled, function (state, _ref4) {
      var payload = _ref4.payload;
      state.userPreferences.status = "done";
      state.userPreferences.payload = payload;
    }).addCase(updateUserPreferences.rejected, function (state) {
      state.userPreferences.status = "error";
    });
  }
});
export default userPreferencesSlice.reducer;
export var selectUserPreferences = function selectUserPreferences(state) {
  var _state$userPreference, _state$userPreference2;
  return (_state$userPreference = state.userPreferences) === null || _state$userPreference === void 0 ? void 0 : (_state$userPreference2 = _state$userPreference.userPreferences) === null || _state$userPreference2 === void 0 ? void 0 : _state$userPreference2.payload;
};
export var selectUserPreferencesStatus = function selectUserPreferencesStatus(state) {
  var _state$userPreference3, _state$userPreference4;
  return (_state$userPreference3 = state.userPreferences) === null || _state$userPreference3 === void 0 ? void 0 : (_state$userPreference4 = _state$userPreference3.userPreferences) === null || _state$userPreference4 === void 0 ? void 0 : _state$userPreference4.status;
};